import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../App";
import { isLeadership } from "../lib/roleAccess";
import { LayoutDashboard, UserRound } from "lucide-react";

// OCI V2.19 — Simple VIEW toggle for leadership (team_leader and above).
// Navigates between the Campaign/Management Dashboard (/owner) and the
// Fundraiser Workspace (/dashboard). No permission change — pure navigation.
export function DualViewSwitcher() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  if (!isLeadership(user)) return null;

  const onOwner = location.pathname.startsWith("/owner");
  const onWorkspace = location.pathname.startsWith("/dashboard");

  const base = "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md transition-colors";
  const active = "bg-white text-slate-900 shadow-sm";
  const idle = "text-slate-500 hover:text-slate-800";

  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-lg bg-slate-100 border border-slate-200"
         data-testid="dual-view-switcher">
      <button
        type="button"
        data-testid="dual-view-campaign"
        onClick={() => navigate("/owner")}
        className={`${base} ${onOwner ? active : idle}`}>
        <LayoutDashboard className="h-3.5 w-3.5" />
        Campaign Dashboard
      </button>
      <button
        type="button"
        data-testid="dual-view-workspace"
        onClick={() => navigate("/dashboard")}
        className={`${base} ${onWorkspace ? active : idle}`}>
        <UserRound className="h-3.5 w-3.5" />
        Fundraiser Workspace
      </button>
    </div>
  );
}

export default DualViewSwitcher;
